module.exports = __webpack_public_path__ + "static/media/gsuite-scanned-vs-alerts.d072bb76.png";